<nav class="navbar navbar-expand-sm navbar-dark d-lg-block d-none" aria-label="Main navigation">

  <div class="container-fluid">

    <a class="navbar-brand" href="/" aria-label="{{ 'logoText' | translate }}" title="{{ 'logoText' | translate }}">

      <img class="menu-logo-img BR-1" src="/assets/logos/logo.webp" alt="{{ 'logoText' | translate }}" width="180"
        height="48" />
    </a>

    <span class="menu-tagline mx-2 text-white">
      {{ 'tagline' | translate }}
    </span>

    <button name="menu-button" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar"
      aria-controls="mynavbar" aria-expanded="false" aria-label="Toggle navigation">

      <span class="navbar-toggler-icon" aria-hidden="true"></span>
    </button>

    <div class="collapse navbar-collapse" id="mynavbar">

      <ul class="navbar-nav mx-5">
        @for (item of menuModel().items; track item.id) {
        <li class="nav-item">
          @if(item.targetLink == '') {
          <a class="nav-link" [routerLink]="['/', currentLang]" [title]="item.name | translate">
            <span class="main-menu-icon" aria-hidden="true">
              <i class="mx-2" [class]="item.icon"></i>
            </span>
            <span class="main-menu-label">
              {{ item.name | translate }}
            </span>
          </a>
          }@else {
          <a class="nav-link" [routerLink]="['/', currentLang, item.targetLink]" [title]="item.name | translate">
            <span class="main-menu-icon" aria-hidden="true">
              <i class="mx-2" [class]="item.icon"></i>
            </span>
            <span class="main-menu-label">
              {{ item.name | translate }}
            </span>
          </a>
          }

        </li>

        }
      </ul>

    </div>

    <app-change-language-component />

  </div>
</nav>
<div class="navbar navbar-dark d-block d-lg-none col-12">

  <div class="mobile-menu-header d-flex w-100 justify-content-between align-items-center">

    <a href="/" aria-label="{{ 'logoText' | translate }}" title="{{ 'logoText' | translate }}">

      <img class="menu-logo-img BR-1" src="/assets/logos/logo.webp" alt="{{ 'logoText' | translate }}" width="180"
        height="48" />
    </a>

    <button name="btn-menu" class="navbar-toggler mx-3" type="button" (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuActive()" aria-controls="mobile-menu" aria-label="Toggle navigation">

      <span class="navbar-toggler-icon" aria-hidden="true"></span>
    </button>

  </div>


  <div id="mobile-menu" class="mobile-menu" [class.mobile-menu-active]="mobileMenuActive()">

    <nav class="menu-box" aria-label="Mobile navigation">

      <div class="d-flex container justify-content-between align-items-center">

        <a href="/" aria-label="{{ 'logoText' | translate }}" title="{{ 'logoText' | translate }}">

          <img class="menu-logo-img BR-1" src="/assets/logos/logo.webp" alt="{{ 'logoText' | translate }}" width="180"
            height="48" />

        </a>

        <button type="button" class="close-btn" (click)="closeMobileMenu()" aria-label="Close navigation">

          <i class="fa-solid fa-times text-white" aria-hidden="true">
          </i>

        </button>

      </div>

      <hr class="text-white">

      <p class="menu-tagline mx-2 text-white text-center">
        {{ 'tagline' | translate }}
      </p>

      <hr class="text-white p-0 m-0">


      <div class="menu-outer">

        <ul class="px-1 no-bullet">

          @for (item of menuModel().items; track item.id) {
          <li class="col-12">
            @if(item.targetLink == '') {
            <a class="col-12" [routerLink]="['/', currentLang]" [title]="item.name | translate"
              (click)="closeMobileMenu()">
              <i class="mx-2" [class]="item.icon" aria-hidden="true">
              </i>
              <span>
                {{ item.name | translate }}
              </span>
            </a>
            }@else {
            <a class="col-12" [routerLink]="['/', currentLang, item.targetLink]" [title]="item.name | translate"
              (click)="closeMobileMenu()">
              <i class="mx-2" [class]="item.icon" aria-hidden="true">
              </i>
              <span>
                {{ item.name | translate }}
              </span>
            </a>
            }

          </li>

          }

        </ul>

      </div>


      <div class="contact-info">

        <div class="icon-box" aria-hidden="true">
          <span class="icon-call"></span>
        </div>

        <p>
          <a href="tel:+420723454349">
            (+420) 723 454 349
          </a>
        </p>

      </div>


      <div class="contact-info">
        <app-change-language-component />
      </div>


      <hr class="text-white pb-0 mb-0">


      <div class="social-links">

        <ul class="d-flex mx-3">

          <li>
            <a href="#" aria-label="Facebook">
              <i class="fab fa-facebook-f" aria-hidden="true"></i>
            </a>
          </li>

          <li>
            <a href="#" aria-label="Twitter">
              <i class="fab fa-twitter" aria-hidden="true"></i>
            </a>
          </li>

          <li>
            <a href="#" aria-label="Instagram">
              <i class="fab fa-instagram" aria-hidden="true"></i>
            </a>
          </li>

          <li>
            <a href="#" aria-label="LinkedIn">
              <i class="fab fa-linkedin-in" aria-hidden="true"></i>
            </a>
          </li>

          <li>
            <a href="#" aria-label="YouTube">
              <i class="fab fa-youtube" aria-hidden="true"></i>
            </a>
          </li>

        </ul>

      </div>

    </nav>
  </div>

</div>


@if (mobileMenuActive()) {
<div class="mobile-overlay" (click)="closeMobileMenu()">
</div>
}